import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import PageContent from '../../components/page-content/page-content';
import {Button, Table, DatePicker} from 'antd';
import {getStat1} from '../../lib/api_stat'
import Box from '../../components/box';
import moment from 'moment';
import excelUtil from '../../lib/excelUtil.js'
import JiaoAn2 from './jiaolian2'

const {Column} = Table;


// @hasAuth
class Staff extends Component {
    state = {
        date: moment(),
        list: [],

        detailItem: null
    };

    componentDidMount() {
        // console.log(this);
        // this.hasRole();
        this.loadData()
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    loadData = () => {
        let begin_time = this.state.date.format("YYYY-MM-01");
        let end_time = moment(this.state.date).endOf('month').format("YYYY-MM-DD");
        getStat1(begin_time, end_time)
            .then((result) => {
                if (result.code === 0) {
                    this.setState({
                        list: this.dealData(result.data)
                    })
                    // this.props.setStaff(result.data);
                } else {

                }
            })
    };

    dealData = (data) => {
        let list = [];
        let count1v1 = 0;
        let count主教 = 0;
        let count助教 = 0;
        let count散客 = 0;
        let count其他人数 = 0;
        let count其他分钟 = 0;
        let count合计 = 0;
        let count处罚 = 0;
        data.forEach((item) => {
            // 潜在按时长拆分（15/30/45），兼容老数据（只有聚合的潜在，无拆分字段时全部按45分钟计）
            let qianzai15 = item["潜在15分钟"] || 0;
            let qianzai30 = item["潜在30分钟"] || 0;
            let qianzai45 = item["潜在45分钟"] || 0;
            let qianzaiOld = item["潜在"] || 0;
            if (qianzaiOld > 0 && (qianzai15 + qianzai30 + qianzai45) === 0) {
                qianzai45 = qianzaiOld;
            }
            let qianzaiRenshu = qianzai15 + qianzai30 + qianzai45;
            let qianzaiMinutes = qianzai15 * 15 + qianzai30 * 30 + qianzai45 * 45;

            let countsanke = item["散客15分钟"] * 15 + item["散客30分钟"] * 30 + item["散客45分钟"] * 45;
            // 会员1V1需剔除混入的潜在45分钟，避免重复计算
            let count1v1_i = item["45分钟"] - item["散客45分钟"] - qianzai45;
            let count = count1v1_i
                + item["主教"] / 0.8 / 45 + item["助教"] / 45
                + countsanke / 45 + qianzaiMinutes / 45;
            let countchufa = item["处罚"] * 45 + item["小组处罚"];

            count1v1 += count1v1_i;
            count主教 += item["主教"] / 0.8 / 45;
            count助教 += item["助教"] / 45;
            count散客 += countsanke;
            count其他人数 += qianzaiRenshu;
            count其他分钟 += qianzaiMinutes;
            count合计 += count;
            count处罚 += countchufa;

            list.push({
                ...item,
                "教练": item["教练"],
                "1V1": count1v1_i.toFixed(2),
                "主教": (item["主教"] / 0.8 / 45).toFixed(2),
                "助教": (item["助教"] / 45).toFixed(2),
                "散客": `${(countsanke / 45).toFixed(2)}(${countsanke})`,
                "其他": `${qianzaiRenshu}(${qianzaiMinutes})`,
                "合计": `${count.toFixed(2)}(${Math.round(count * 45)})`,
                "处罚": `${(countchufa / 45).toFixed(2)}(${countchufa})`,
            });

        })
        list.push({
            "教练": "合计",
            "1V1": count1v1.toFixed(2),
            "主教": count主教.toFixed(2),
            "助教": count助教.toFixed(2),
            "散客": `${(count散客 / 45).toFixed(2)}(${count散客})`,
            "其他": `${count其他人数}(${count其他分钟})`,
            "合计": `${count合计.toFixed(2)}(${Math.round(count合计 * 45)})`,
            "处罚": `${(count处罚 / 45).toFixed(2)}(${count处罚})`,
        })
        return list;
    }

    onChange = (date, dateString) => {
        console.log(date, dateString);
        this.setState({
            date: date
        }, () => {
            this.loadData()
        })
    };

    columns = [{
        title: '教练姓名',
        dataIndex: '教练',
        key: '教练',
    }, {
        title: '会员(1V1)',
        dataIndex: '1V1',
        key: '1V1',
    }, {
        title: '会员(主教)',
        dataIndex: '主教',
        key: '主教',
    }, {
        title: '会员(助教)',
        dataIndex: '助教',
        key: '助教',
    }, {
        title: '散客(度假套餐等)',
        dataIndex: '散客',
        key: '散客',
    }, {
        title: '其他(免费体验等)',
        dataIndex: '其他',
        key: '其他',
    }, {
        title: '合计',
        dataIndex: '合计',
        key: '合计',
    }, {
        title: '处罚',
        dataIndex: '处罚',
        key: '处罚',
    }];

    exportXlsx = () => {
        excelUtil.exportExcel(this.columns, this.state.list, `${this.state.date.format("YYYY年M月")}课时统计.xlsx`)
    };


    render() {
        let {list, detailItem} = this.state;
        let begin_time = this.state.date.format("YYYY-MM-01");
        let end_time = moment(this.state.date).endOf('month').format("YYYY-MM-DD");
        return (

            <Box>
                <DatePicker
                    allowClear={false}
                    onChange={this.onChange}
                    value={this.state.date}
                    picker="month"/>
                <Button onClick={this.exportXlsx}>导出</Button>
                <Table
                    dataSource={list}
                    rowKey={"教练"}
                    pagination={false}
                    size={"small"}
                >
                    <Column
                        title="教练姓名"
                        dataIndex="教练"
                        key="教练"
                        render={(_, record) => {
                            return <a onClick={() => this.setState({detailItem: record})}>{record["教练"]}</a>
                        }}
                    />
                    <Column
                        title={<>会员<br/>(1V1)</>}
                        dataIndex="1V1"
                        key="1V1"
                        width={100}
                        align="center"
                    />
                    <Column
                        title={<>会员<br/>(主教)</>}
                        dataIndex="主教"
                        key="主教"
                        width={100}
                        align="center"
                    />
                    <Column
                        title={<>会员<br/>(助教)</>}
                        dataIndex="助教"
                        key="助教"
                        width={100}
                        align="center"
                    />
                    <Column
                        title={<>散客<br/>(度假套餐等)</>}
                        dataIndex="散客"
                        key="散客"
                        width={100}
                        align="center"
                    />
                    <Column
                        title={<>其他<br/>(免费体验等)</>}
                        dataIndex="其他"
                        key="其他"
                        width={100}
                        align="center"
                    />
                    <Column
                        title={<>合计</>}
                        dataIndex="合计"
                        key="合计"
                        width={100}
                        align="center"
                    />
                    <Column
                        title={<>处罚</>}
                        dataIndex="处罚"
                        key="处罚"
                        width={100}
                        align="center"
                    />

                </Table>
                <div style={{color: "red"}}>
                    备注：以上数据包含赠券课时
                </div>

                <Table
                    dataSource={list}
                    rowKey={"教练"}
                    pagination={false}
                    size={"small"}
                >
                    <Column
                        title="教练"
                        dataIndex="教练"
                        key="教练"
                        render={(_, record) => {
                            return <a onClick={() => this.setState({detailItem: record})}>{record["教练"]}</a>
                        }}
                    />
                    <Column
                        title="免费邀约（分钟）"
                        dataIndex="免费邀约"
                        key="免费邀约"
                        width={140}
                        align="center"
                    />
                </Table>
                {detailItem &&
                    <JiaoAn2
                        visible={true}
                        nick_name={detailItem["教练"]}
                        begin_time={begin_time}
                        end_time={end_time}
                        onClose={() => {
                            this.setState({detailItem: null})
                        }
                        }
                    />
                }
            </Box>


        );
    }
}


export default withRouter(Staff);



